import {slice, sumBy} from 'lodash';

const defaultColors = [
    '#FFB900',
    '#D83B01',
    '#B50E0E',
    '#E81123',
    '#B4009E',
    '#5C2D91',
    '#0078D7',
    '#00B4FF',
    '#008272',
    '#107C10'
];

function calculateColor(word: string, colors: string[] = defaultColors): string {
    const wordSum = sumBy(word, (char) => char.charCodeAt(0));
    return colors[wordSum % colors.length];
}

function getPaginatedData<T>(items: T[], page: number, pageSize: number) {
    const startIndex = (page - 1) * pageSize;
    return slice(items, startIndex, startIndex + pageSize);
}

export const calculateUtils = {
    calculateColor,
    getPaginatedData
};
